module.exports = __webpack_public_path__ + "img/cover.4bc52a07.webp";